<!-- components/Toaster.vue -->

<template>
    <div class="toast-container">
        <TransitionGroup name="toast">
            <div
                v-for="(toast, index) in toasts"
                :key="toast.id"
                class="toast"
                :class="`toast--${toast.type}`"
                :style="getToastStyle(index)"
                @click="toast.dismissible && remove(toast.id)">
                <div class="toast-icon">
                    <Icon :icon="toast.icon" />
                </div>
                <div class="toast-content">
                    <div v-if="toast.title" class="toast-title">
                        {{ toast.title }}
                    </div>
                    <p class="toast-message" v-if="toast.message">
                        {{ toast.message }}
                    </p>
                </div>
                <!-- <button
                    v-if="toast.dismissible"
                    class="toast-close"
                    @click.stop="remove(toast.id)">
                    &times;
                </button> -->
            </div>
        </TransitionGroup>
    </div>
</template>
<script setup>
import { useToast } from "@/composables/useToast";
import { TransitionGroup } from "vue";
import { Icon } from "@iconify/vue";
const { toasts, remove } = useToast();

const getToastStyle = (index) => {
    return {
        transform: `translateY(${index * 10}px)`,
        marginTop: `${index * 0.5}rem`,
    };
};
</script>
<style lang="less" scoped>
.toast-container {
    position: fixed;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    gap: var(--brand-space-300);
}

.toast {
    .box-sizing(300);
    padding: var(--brand-scale-300) var(--brand-scale-400);
    border-radius: var(--brand-scale-100);

    position: relative;
    display: flex;
    align-items: flex-start;
    gap: var(--brand-scale-300);
    background: var(--mapped-surface-seccuss-default-subtle);
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: var(--responsive-paragraph-sm-text-size);
    font-style: normal;
    font-weight: 400;
    line-height: var(--responsive-paragraph-sm-line-height);
}

.toast--success {
    border: 1px solid var(--mapped-border-success-default);
    background: var(--mapped-surface-seccuss-default-subtle);
    color: var(--mapped-text-success-default);
    .toast-icon {
        color: var(--mapped-text-success-default);
    }
}

.toast--error {
    border: 1px solid var(--mapped-border-error-default);
    background: var(--mapped-surface-error-default-subtle);
    color: var(--mapped-text-error-default);
    .toast-icon {
        color: var(--mapped-text-error-default);
    }
}

.toast--warning {
    border: 1px solid var(--mapped-border-warning-default);
    background: var(--mapped-surface-warning-default-subtle);
    color: var(--mapped-text-warning-default);
    .toast-icon {
        color: var(--mapped-text-warning-default);
    }
}

.toast--info {
}

.toast-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
    margin-right: var(--size-space-300);
}

.toast-content {
    flex: 1;
}

.toast-title {
    color: var(--color-text-default-default);
    font-size: var(--typography-body-size-small);
    font-style: normal;
    font-weight: var(--typography-weight-regular);
    line-height: normal;
}

.toast-message {
    color: var(--color-text-default-default);
    font-size: var(--typography-body-size-small);
    font-style: normal;
    font-weight: var(--typography-weight-regular);
    line-height: normal;
}

.toast-close {
    margin-left: 0.5rem;
    background: none;
    border: none;
    font-size: 1.25rem;
    cursor: pointer;
    opacity: 0.7;
}

/* 动画效果 */
.toast-enter-from,
.toast-leave-to {
    opacity: 0;
    transform: translateY(-100%);
}

.toast-enter-active,
.toast-leave-active {
    transition: all 0.3s ease;
}

.toast-move {
    transition: transform 0.3s ease;
}
</style>
